export default __webpack_public_path__ + "static/media/col-image-6_370x450_crop_center.progressive.5a6f23b4.jpg";